import { useState } from "react";

// Cross-sell scoped to Vial-Kit PDPs only (not raw vial pages). Renders a
// pre-checked, removable toggle so the buyer opts *out* rather than in.
// The default-on framing matches how the physical kit ships (the vial is
// useless without a needle) while still respecting buyers who prefer
// BYO-syringe. State is local to this component, the vial kit itself
// already covers the core accessories in its "What's included" list; this
// toggle expresses "keep the extra 10-pack of needles in my order?".
export default function VialKitAccessoryToggle() {
  const [included, setIncluded] = useState(true);
  return (
    <label
      className="mt-4 flex cursor-pointer items-start gap-3 rounded-lg border border-brandblue/30 bg-white/70 p-3 transition-colors hover:border-brandblue"
      data-testid="vial-kit-accessory-toggle"
    >
      <input
        type="checkbox"
        checked={included}
        onChange={(e) => setIncluded(e.target.checked)}
        className="mt-1 h-4 w-4 shrink-0 accent-brandblue"
        data-testid="vial-kit-accessory-toggle-input"
      />
      <span className="flex-1">
        <span className="font-heading text-sm font-bold text-ink">
          Include extra accessory kit
        </span>
        <span className="mt-0.5 block text-xs text-subtle">
          Additional 10-pack of insulin syringes, alcohol wipes, and a spare sharps
          disposal container. Pre-checked, uncheck to skip. Included at no extra
          cost with this kit.
        </span>
        <span
          className={`mt-1 inline-block font-mono text-[10px] tracking-[0.14em] ${
            included ? "text-brandblue" : "text-subtle"
          }`}
          data-testid="vial-kit-accessory-toggle-status"
        >
          {included ? "● INCLUDED" : "○ NOT INCLUDED"}
        </span>
      </span>
    </label>
  );
}
